<template>
    <fieldset>
        <h2>General settings</h2>
        <loading-indicator v-if="GeneralSettings === null" />
        <label v-if="GeneralSettings !== null">Unauthorised Summary Email Time: <input type="time" v-model="GeneralSettings.timeofDayToSendUnapprovedEmail" /></label>
        <label v-if="GeneralSettings !== null">User reminder to confirm email delay: <input type="number" v-model.number="GeneralSettings.timeDelayForUserConfirmationReminderInHours" /> hours</label>
        <label v-if="GeneralSettings !== null">Internal email when user confirms email late delay: <input type="number" v-model.number="GeneralSettings.timeDelayForInternalConfirmationInHours" /> hours</label>
        <br /><button @click="saveGeneralSettings">Update Generate Settings</button>
        <h2>Registration Notifications</h2>
        <loading-indicator v-if="RegistrationNotifications === null" />
        <ul v-if="RegistrationNotifications !== null && RegistrationNotifications.length > 0">
            <li v-for="(email, index) in RegistrationNotifications" :key="index">{{email}} - <a href="#" @click="deleteRegistrationNotification(email)">Remove</a></li>
        </ul>
        <p v-if="RegistrationNotifications !== null && RegistrationNotifications.length === 0">No registration notifications.</p>
        <label v-if="RegistrationNotifications !== null">Add email: <input type="email" v-model="EmailToAdd" /> <button @click="addRegistrationNotification">Add</button></label>

        <h2>Summary Registration Notifications</h2>
        <loading-indicator v-if="RegistrationSummaryNotifications === null" />
        <ul v-if="RegistrationSummaryNotifications !== null && RegistrationSummaryNotifications.length > 0">
            <li v-for="(email, index) in RegistrationSummaryNotifications" :key="index">{{email}} - <a href="#" @click="deleteSummaryRegistrationNotification(email)">Remove</a></li>
        </ul>
        <p v-if="RegistrationSummaryNotifications !== null && RegistrationSummaryNotifications.length === 0">No summary registration notifications.</p>
        <label v-if="RegistrationSummaryNotifications !== null">Add email: <input type="email" v-model="SummaryEmailToAdd" /> <button @click="addSummaryRegistrationNotification">Add</button></label>

        <h2>Restricted Email Domains</h2>
        <loading-indicator v-if="RestrictedEmailDomains === null" />
        <ul v-if="RestrictedEmailDomains !== null && RestrictedEmailDomains.length > 0">
            <li v-for="(domain, index) in RestrictedEmailDomains" :key="index">{{domain}} - <a href="#" @click="deleteRestrictedEmailDomains(domain)">Remove</a></li>
        </ul>
        <p v-if="RestrictedEmailDomains !== null && RestrictedEmailDomains.length === 0">No registration email domains.</p>
        <label v-if="RestrictedEmailDomains !== null">Add domain: <input v-model="RestrictedEmailDomainToAdd" /> <button @click="addRestrictedEmailDomains">Add</button></label>
        <h2>Network/Support Groups ({{this.NetworkSupportGroups.length}} Records)</h2>
        <loading-indicator v-if="NetworkSupportGroups === null" />
        <p v-if="NetworkSupportGroups === null">No network/support groups.</p>
        <div v-if="RestrictedEmailDomains !== null">
            <table>
                <tr>
                    <td>
                        Add network/support group:
                    </td>
                    <td>
                        <input v-model="NetworkSupportGroupToAdd" />
                    </td>
                </tr>
                <tr>
                    <td>
                        Select the subscription pricing:
                    </td>
                    <td>
                        <select v-model="NetworkSupportGroupStripePriceToAdd">
                            <option v-for="stripe in stripePrices" :key="stripe.priceId" :value="stripe.priceId">{{stripe.name}} | {{stripe.price}} {{stripe.currency}} </option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>Maximum no of licenses that can be bought online:</td>
                    <td><nullable-integer-input v-model="NetworkSupportGroupMaxLicenseToAdd" /> </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <button @click="addNetworkSupportGroup">Add</button>
                    </td>
                </tr>
            </table>
        </div>
        <table class="NetworkTable">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Subscription pricing</th>
                    <th>Maximum no of License</th>
                    <th>Option</th>
                </tr>
            </thead>
            <tbody v-if="NetworkSupportGroups === null">
                <tr>
                    <td colspan="4" class="LoadingCell">
                        <loading-indicator v-if="NetworkSupportGroups === null" />
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="grp in NetworkSupportGroups" :key="grp.networkSupportGroupId">
                    <td>
                        {{grp.name}}
                    </td>
                    <td v-if="!grp.isEditing">
                        {{ getStripePriceById(grp.pgpPriceID) }}
                    </td>
                    <td v-if="grp.isEditing">
                        <label>
                            <select v-model="grp.pgpPriceID">
                                <option v-for="stripe in stripePrices" :key="stripe.priceId" :value="stripe.priceId">{{stripe.name}} | {{stripe.price}} {{stripe.currency}} </option>
                            </select>
                        </label>
                    </td>
                    <td v-if="!grp.isEditing">
                        {{grp.maxLicensesAllow}}
                    </td>
                    <td v-if="grp.isEditing">
                        <label><nullable-integer-input v-model="grp.maxLicensesAllow" /> </label>
                    </td>
                    <td v-if="grp.isEditing">
                        <button v-if="grp.isEditing" @click="UpdateNetworkSupportGroups(grp)">Save</button> |
                        <button v-if="grp.isEditing" @click="grp.isEditing = false">Cancel</button>
                    </td>
                    <td v-if="!grp.isEditing">
                        <button v-if="!grp.isEditing" @click="grp.isEditing = true">Edit</button> |
                        <button v-if="!grp.isEditing" @click="deleteNetworkSupportGroups(grp.networkSupportGroupId)">Remove</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <h2>Wordpress Services</h2>
        <h3>Adviser Software Insights</h3>
        <loading-indicator v-if="ASIServices === null" />
        <ul v-if="ASIServices !== null && ASIServices.length > 0">
            <li v-for="(service, index) in ASIServices" :key="index">{{service.wordpressServiceName}} - <a href="#" v-if="service.canDelete" @click="deleteASIService(service)">Remove</a><i v-else title="This service is assigned to a company/role and cannot be deleted">Remove</i></li>
        </ul>
        <p v-if="ASIServices !== null && ASIServices.length === 0">No Adviser Software Insights Services.</p>
        <label v-if="ASIServiceToAdd !== null">Add service: <input v-model="ASIServiceToAdd" /> <button @click="addASIService">Add</button></label>
        <h3>Benefits Guru</h3>
        <loading-indicator v-if="BenefitsGuruServices === null" />
        <ul v-if="BenefitsGuruServices !== null && BenefitsGuruServices.length > 0">
            <li v-for="(service, index) in BenefitsGuruServices" :key="index">{{service.wordpressServiceName}} - <a href="#" v-if="service.canDelete" @click="deleteBenefitsGuruService(service)">Remove</a><i v-else title="This service is assigned to a company/role and cannot be deleted">Remove</i></li>
        </ul>
        <p v-if="BenefitsGuruServices !== null && BenefitsGuruServices.length === 0">No Benefits Guru Services.</p>
        <label v-if="BenefitsGuruServiceToAdd !== null">Add service: <input v-model="BenefitsGuruServiceToAdd" /> <button @click="addBenefitsGuruService">Add</button></label>
        <h3>Protection Guru</h3>
        <loading-indicator v-if="ProtectionGuruServices === null" />
        <ul v-if="ProtectionGuruServices !== null && ProtectionGuruServices.length > 0">
            <li v-for="(service, index) in ProtectionGuruServices" :key="index">{{service.wordpressServiceName}} - <a href="#" v-if="service.canDelete" @click="deleteProtectionGuruService(service)">Remove</a><i v-else title="This service is assigned to a company/role and cannot be deleted">Remove</i></li>
        </ul>
        <p v-if="ProtectionGuruServices !== null && ProtectionGuruServices.length === 0">No Protection Guru Services.</p>
        <label v-if="ProtectionGuruServiceToAdd !== null">Add service: <input v-model="ProtectionGuruServiceToAdd" /> <button @click="addProtectionGuruService">Add</button></label>

    </fieldset>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import $ from 'jquery';
    import NullableIntegerInput from './NullableIntegerInput.vue';

    export default {
        name: 'Settings',
        components: { LoadingIndicator, NullableIntegerInput },
        data: function () {
            return {
                RegistrationNotifications: null,
                RegistrationSummaryNotifications: null,
                RestrictedEmailDomainToAdd: "",
                NetworkSupportGroups: null,
                NetworkSupportGroupToAdd: "",
                NetworkSupportGroupStripePriceToAdd: "",
                NetworkSupportGroupMaxLicenseToAdd: "",
                RestrictedEmailDomains: null,
                ProtectionGuruServices: null,
                ProtectionGuruServiceToAdd: "",
                EmailToAdd: "",
                SummaryEmailToAdd: "",
                BenefitsGuruServices: null,
                BenefitsGuruServiceToAdd: "",
                ASIServices: null,
                ASIServiceToAdd: "",
                GeneralSettings: null,
                stripePrices: [],
            }
        },
        created: function () {
            this.loadGeneralSettings();
            this.loadRegistrationNotifications();
            this.loadSummaryRegistrationNotifications();
            this.loadProtectionGuruServices();
            this.loadBenefitsGuruServices();
            this.loadASIServices();
            this.loadRestrictedEmailDomain();
            this.loadNetworkSupportGroups();
            this.getStripePrice();
        },
        methods: {
            loadGeneralSettings: function () {
                var thisControl = this;
                thisControl.GeneralSettings = null;
                fetch('Settings/General',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }
                ).then(function (response) {
                    return response.json();
                }
                ).then(function (data) {

                    thisControl.GeneralSettings = data;
                }
                );
            },
            saveGeneralSettings: function () {
                var thisControl = this;
                var settings = thisControl.GeneralSettings;
                thisControl.GeneralSettings = null;
                fetch('Settings/General',
                    {
                        method: 'POST',
                        body: JSON.stringify(settings),
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }
                ).then(function () {

                    thisControl.loadGeneralSettings();
                }
                );
            },
            addNetworkSupportGroup: function () {
                var thisControl = this;

                if (thisControl.NetworkSupportGroupToAdd === null || thisControl.NetworkSupportGroupToAdd === "") {
                    alert("You must supply a Network Name.")
                    return;
                }

                if (thisControl.NetworkSupportGroups !== null && thisControl.NetworkSupportGroups.length > 0 && thisControl.NetworkSupportGroups.filter(function (itm) { return itm.name == thisControl.NetworkSupportGroupToAdd }).length > 0) {
                    alert("Network group name is already exist.")
                    return;
                }

                var model = {
                    Name: thisControl.NetworkSupportGroupToAdd,
                    PGPPriceID: thisControl.NetworkSupportGroupStripePriceToAdd,
                    MaxLicensesAllow: thisControl.NetworkSupportGroupMaxLicenseToAdd,
                };

                fetch('Settings/NetworkSupportGroup',
                    {
                        method: 'PUT',
                        body: JSON.stringify(model),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then(function () {
                    alert("Record added successfully...");
                    thisControl.NetworkSupportGroupToAdd = "";
                    thisControl.NetworkSupportGroupStripePriceToAdd = "";
                    thisControl.NetworkSupportGroupMaxLicenseToAdd = "";
                    thisControl.loadNetworkSupportGroups();
                });
            },
            deleteNetworkSupportGroups: function (id) {
                var thisControl = this;
                thisControl.NetworkSupportGroups = null;
                fetch('Settings/NetworkSupportGroup',
                    {
                        method: 'DELETE',
                        body: JSON.stringify(id),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then(function () {
                    alert("Record removed successfully...");
                    thisControl.loadNetworkSupportGroups();
                });
            },
            loadNetworkSupportGroups: function () {
                var thisControl = this;
                thisControl.NetworkSupportGroups = null;

                $.ajax({
                    type: 'GET',
                    url: 'Settings/NetworkSupportGroup',
                    dataType: 'json',
                    success: function (data) {
                        data.forEach((item) => {
                            item.isEditing = false;
                        })
                        thisControl.NetworkSupportGroups = data;
                    }

                });
            },
            addRestrictedEmailDomains: function () {
                var thisControl = this;
                thisControl.RestrictedEmailDomains = null;
                $.ajax({
                    type: 'PUT',
                    data: JSON.stringify(this.RestrictedEmailDomainToAdd),
                    url: 'Settings/RestrictedEmailDomains',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.RestrictedEmailDomainToAdd = "";
                        thisControl.loadRestrictedEmailDomain();
                    }

                });
            },
            deleteRestrictedEmailDomains: function (domain) {
                var thisControl = this;
                thisControl.RestrictedEmailDomains = null;
                $.ajax({
                    type: 'DELETE',
                    data: JSON.stringify(domain),
                    url: 'Settings/RestrictedEmailDomains',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.loadRestrictedEmailDomain();
                    }

                });
            },
            loadRestrictedEmailDomain: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/RestrictedEmailDomains',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.RestrictedEmailDomains = data;
                    }

                });
            },

            addSummaryRegistrationNotification: function () {
                var thisControl = this;
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.SummaryEmailToAdd)) {
                    thisControl.RegistrationSummaryNotifications = null;
                    fetch('Settings/RegistrationSummaryNotifications',
                        {
                            method: 'PUT',
                            body: JSON.stringify(this.SummaryEmailToAdd),
                            headers: {
                                'Content-Type': 'application/json'
                                // 'Content-Type': 'application/x-www-form-urlencoded',
                            }
                        }
                    ).then(function () {

                        thisControl.SummaryEmailToAdd = "";
                        thisControl.loadSummaryRegistrationNotifications();
                    }
                    );
                }
                else
                    alert("Please entered a valid email address!");
                return false;
            },
            deleteSummaryRegistrationNotification: function (email) {
                var thisControl = this;
                thisControl.RegistrationSummaryNotifications = null;
                fetch('Settings/RegistrationSummaryNotifications',
                    {
                        method: 'DELETE',
                        body: JSON.stringify(email),
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }
                ).then(function () {
                    thisControl.loadSummaryRegistrationNotifications();
                }
                );
            },
            loadSummaryRegistrationNotifications: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/RegistrationSummaryNotifications',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.RegistrationSummaryNotifications = data;
                    }

                });
            },

            addRegistrationNotification: function () {
                var thisControl = this;
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.EmailToAdd)) {
                    thisControl.RegistrationNotifications = null;
                    $.ajax({
                        type: 'PUT',
                        data: JSON.stringify(this.EmailToAdd),
                        url: 'Settings/RegistrationNotifications',
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function () {
                            thisControl.EmailToAdd = "";
                            thisControl.loadRegistrationNotifications();
                        }

                    });
                }
                else
                    alert("Please entered a valid email address!");
                return false;
            },
            deleteRegistrationNotification: function (email) {
                var thisControl = this;
                thisControl.RegistrationNotifications = null;
                $.ajax({
                    type: 'DELETE',
                    data: JSON.stringify(email),
                    url: 'Settings/RegistrationNotifications',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.loadRegistrationNotifications();
                    }

                });
            },
            loadRegistrationNotifications: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/RegistrationNotifications',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.RegistrationNotifications = data;
                    }

                });
            },
            addProtectionGuruService: function () {
                var thisControl = this;
                if (this.ProtectionGuruServiceToAdd.trim() !== "") {
                    thisControl.ProtectionGuruServices = null;
                    $.ajax({
                        type: 'PUT',
                        data: JSON.stringify(this.ProtectionGuruServiceToAdd.trim()),
                        url: 'Settings/ProtectionGuruServices',
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function () {
                            thisControl.ProtectionGuruServiceToAdd = "";
                            thisControl.loadProtectionGuruServices();
                        }

                    });
                }
                else
                    alert("Please entered a service name!");
                return false;
            },
            deleteProtectionGuruService: function (service) {
                var thisControl = this;
                thisControl.ProtectionGuruServices = null;
                $.ajax({
                    type: 'DELETE',
                    data: JSON.stringify(service.wordpressServiceName),
                    url: 'Settings/ProtectionGuruServices',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.loadProtectionGuruServices();
                    }

                });
            },
            loadProtectionGuruServices: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/ProtectionGuruServices',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.ProtectionGuruServices = data;
                    }

                });
            },
            addBenefitsGuruService: function () {
                var thisControl = this;
                if (this.BenefitsGuruServiceToAdd.trim() !== "") {
                    thisControl.BenefitsGuruServices = null;
                    $.ajax({
                        type: 'PUT',
                        data: JSON.stringify(this.BenefitsGuruServiceToAdd.trim()),
                        url: 'Settings/BenefitsGuruServices',
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function () {
                            thisControl.BenefitsGuruServiceToAdd = "";
                            thisControl.loadBenefitsGuruServices();
                        }

                    });
                }
                else
                    alert("Please entered a service name!");
                return false;
            },
            deleteBenefitsGuruService: function (service) {
                var thisControl = this;
                thisControl.BenefitsGuruServices = null;
                $.ajax({
                    type: 'DELETE',
                    data: JSON.stringify(service.wordpressServiceName),
                    url: 'Settings/BenefitsGuruServices',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.loadBenefitsGuruServices();
                    }

                });
            },
            loadBenefitsGuruServices: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/BenefitsGuruServices',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.BenefitsGuruServices = data;
                    }

                });
            },
            addASIService: function () {
                var thisControl = this;
                if (this.ASIServiceToAdd.trim() !== "") {
                    thisControl.ASIServices = null;
                    $.ajax({
                        type: 'PUT',
                        data: JSON.stringify(this.ASIServiceToAdd.trim()),
                        url: 'Settings/ASIServices',
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function () {
                            thisControl.ASIServiceToAdd = "";
                            thisControl.loadASIServices();
                        }

                    });
                }
                else
                    alert("Please entered a service name!");
                return false;
            },
            deleteASIService: function (service) {
                var thisControl = this;
                thisControl.ASIServices = null;
                $.ajax({
                    type: 'DELETE',
                    data: JSON.stringify(service.wordpressServiceName),
                    url: 'Settings/ASIServices',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function () {
                        thisControl.loadASIServices();
                    }

                });
            },
            loadASIServices: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Settings/ASIServices',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.ASIServices = data;
                    }

                });
            },

            getStripePrice: function () {
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: '/Stripe/getProtectionGuruProProductPrice',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.stripePrices = data;
                    }
                });
            },
            getStripePriceById: function (pgpPriceID) {
                var prieDetails = this.stripePrices.filter(function (itm) { return itm.priceId == pgpPriceID });
                if (prieDetails.length > 0)
                    return prieDetails[0].name + " | " + prieDetails[0].price + " " + prieDetails[0].currency
                return "";
            },
            UpdateNetworkSupportGroups: function (grp) {
                var thisControl = this;

                if (grp.name === null || grp.name === "") {
                    alert("You must supply a Network Name.")
                    return;
                }

                if (thisControl.NetworkSupportGroups !== null && thisControl.NetworkSupportGroups.length > 0 && thisControl.NetworkSupportGroups.filter(function (itm) { return itm.name == grp.name && itm.networkSupportGroupId !== grp.networkSupportGroupId }).length > 0) {
                    alert("Network group name is already exist.")
                    return;
                }

                var model = {
                    NetworkSupportGroupId: grp.networkSupportGroupId,
                    Name: grp.name,
                    PGPPriceID: grp.pgpPriceID,
                    MaxLicensesAllow: grp.maxLicensesAllow,
                };

                fetch('Settings/EditNetworkSupportGroupByID',
                    {
                        method: 'PUT',
                        body: JSON.stringify(model),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then(function () {
                    alert("Record updated successfully...");
                    thisControl.loadNetworkSupportGroups();
                });

                grp.isEditing = false;
                return;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->